import React from "react";
import "./Button.scss";

const Button = ({
  children,
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  type = "button",
  onClick,
  className = "",
  ...rest
}) => {
  const isDisabled = disabled || loading;
  const classes = [
    "tx-btn",
    `tx-btn--${variant}`,
    `tx-btn--${size}`,
    loading && "tx-btn--loading",
    isDisabled && "tx-btn--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={isDisabled}
      onClick={onClick}
      {...rest}
    >
      {loading ? <span className="tx-btn__spinner" aria-hidden="true" /> : children}
    </button>
  );
};

export default Button;
